import { useEffect } from "react";
import { LoadingPanels } from "app/components/analytics/shared/LoadingStates";
import { Build } from "app/components/build/Show/lib/types";
import { CommandJob } from "app/components/build/Show/lib/types/CommandJob";
import { useReactRouterNavigateHandler } from "./lib/useReactRouterNavigateHandler";

type Props = {
  build: Build;
  job?: CommandJob;
};

export default function V2TestEngine({ build, job }: Props) {
  const navigateClickHandler = useReactRouterNavigateHandler();

  const url = job ? job.testEngine.testTabUrl : build.testEngine.testTabUrl;
  const frameId = `te_tests${job ? `_${job.id}` : ""}`;

  useEffect(() => {
    const handler = (event) => {
      if (event.target.id === frameId) {
        localStorage.setItem("hide-test-tab-pill", "true");
      }
    };

    document.addEventListener("turbo:frame-load", handler);
    return () => document.removeEventListener("turbo:frame-load", handler);
  }, [frameId]);

  if (!url) {
    return null;
  }

  return (
    <div data-turbo="true" onClick={navigateClickHandler}>
      <turbo-frame
        className="w-full h-full"
        id={frameId}
        src={url}
        data-executions={true}
        data-controller="error"
        data-action="turbo:frame-missing->error#handleTurboFrameMissing"
      >
        <div className="p-4">
          <LoadingPanels rows={10} columns={1} />
        </div>
      </turbo-frame>
    </div>
  );
}
